export const projetos = [
  {
    id: 1,
    nome: "DashHub",
    emoji: "💻",
    descricao: "Sistema financeiro completo com autenticação Firebase, controle de gastos, usuários, rotina e agenda.",
    descricaoTecnica: "Plataforma fullstack com painel administrativo, autenticação segura via Firebase Auth, CRUD completo de transações financeiras, sistema de agenda integrado e dashboard com métricas em tempo real.",
    tecnologias: ["React", "Firebase", "JavaScript", "CSS", "Firestore"],
    desafios: [
      "Sincronização em tempo real com Firestore",
      "Gestão de estado complexo entre múltiplos módulos",
      "Sistema de autenticação com múltiplos provedores",
    ],
  },
  {
    id: 2,
    nome: "Deploy Server",
    emoji: "🚀",
    descricao: "Sistema próprio para realizar deploy automático via Docker, criação de subdomínios e gerenciamento de aplicações.",
    descricaoTecnica: "Plataforma de automação de deploy que gerencia containers Docker, configura subdomínios automaticamente via Cloudflare DNS e monitora o status das aplicações. Interface de gerenciamento com logs em tempo real.",
    tecnologias: ["Docker", "Azure", "Cloudflare", "C#", ".NET"],
    desafios: [
      "Automação completa do ciclo de deploy",
      "Integração com API do Cloudflare para DNS",
      "Gerenciamento de containers Docker via código",
    ],
  },
];
